<template>
  <v-navigation-drawer :value="value" width="450" temporary fixed right class="pt-12" stateless>
    <v-toolbar absolute width="100%" dense flat color="accent" dark>
      <v-toolbar-title>Filters</v-toolbar-title>
      <v-progress-circular v-show="loading" class="ml-4" indeterminate color="primary" size="24" />
      <v-spacer />
      <v-scale-transition>
        <v-btn v-if="showApply" class="mr-2" color="primary" small depressed :disabled="loading" @click="onApplyClick"
          >Apply Filters</v-btn
        >
      </v-scale-transition>
      <v-scale-transition>
        <v-btn v-if="showClear" class="mr-2" color="error" small depressed :disabled="loading" @click="onClearClick">{{
          clearText
        }}</v-btn>
      </v-scale-transition>
      <v-btn small depressed color="grey lighten-3" class="black--text" @click="onCloseClick">Close</v-btn>
    </v-toolbar>
    <div class="pt-2 pb-6">
      <slot />
    </div>
  </v-navigation-drawer>
</template>
<script>
export default {
  name: 'FilterSidebar',
  props: {
    clearText: {
      type: String,
      default: 'Clear All',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showApply: {
      type: Boolean,
      default: false,
    },
    showClear: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    onApplyClick() {
      this.$emit('apply')
    },
    onClearClick() {
      this.$emit('clear')
    },
    onCloseClick() {
      this.$emit('input', false)
    },
    /**
     * The navigation drawer must be stateless so that we
     * do not mutate the 'value' prop, however this means
     * that clicking the overlay will not close the drawer.
     * This method checks that the overlay itself is clicked
     * and checks no other overlays are open before closing.
     * @param {Object} event The event triggered
     * @param {Node} event.target The Target of an
     */
    onOutsideClick({ target }) {
      const overlays = Array.from(document.getElementsByClassName('v-overlay__scrim'))
      if (target.classList.contains('v-overlay__scrim')) {
        /*  Check overlays length as we don't want to close when clicking the
            overlay of a nested modal such as date-picker */
        if (overlays.length === 1) this.onCloseClick()
      }
    },
  },
}
</script>
